"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentRulesTab = SegmentRulesTab;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_redux_1 = require("react-redux");
var letsachieve_1 = require("../../../../../api/letsachieve");
var read_only_banner_1 = require("../../../../../components/readOnlyBanner/read_only_banner");
var permissions_1 = require("../../../../../hooks/permissions");
var IUser_1 = require("../../../../../interfaces/IUser");
var main_1 = require("../../../../../reducers/slices/main");
var constants_1 = require("../constants");
var rules_1 = require("../rules");
var segment_build_mode_field_1 = require("./segment_build_mode_field");
var segment_rules_builder_1 = require("./segment_rules_builder");
function SegmentRulesSaveForm(_a) {
    var _this = this;
    var segment = _a.segment, rules = _a.rules, on_saved = _a.on_saved;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_3.useState)("future_only"), buildMode = _b[0], setBuildMode = _b[1];
    var _c = (0, letsachieve_1.useUpdateSegmentMutation)(), updateSegment = _c[0], isLoading = _c[1].isLoading;
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateSegment({ segment_id: segment.id, body: { rules: rules, build_mode: buildMode } }).unwrap()];
                case 1:
                    _a.sent();
                    dispatch((0, main_1.setContentModal)(null));
                    on_saved();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when saving the rules!", messages: [(0, constants_1.segmentErrorMessage)(error_1)] }));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm text-muted", children: "Saving rebuilds the segment. Members who still match stay and never run their actions again; members who no longer match leave and run any left actions." }), (0, jsx_runtime_1.jsx)(segment_build_mode_field_1.SegmentBuildModeField, { value: buildMode, on_change: setBuildMode }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row pt-2 gap-4 justify-center", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "tertiary", onPress: function () { return dispatch((0, main_1.setContentModal)(null)); }, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "primary", isPending: isLoading, onPress: handleSave, children: "Save and rebuild" })] })] }));
}
function SegmentRulesTab(_a) {
    var segment = _a.segment;
    var dispatch = (0, react_redux_1.useDispatch)();
    var canUpdate = (0, permissions_1.usePermission)(IUser_1.IPermissions.SEGMENTS).canUpdate;
    var _b = (0, letsachieve_1.useGetSegmentFieldsQuery)(), _c = _b.data, fields = _c === void 0 ? [] : _c, isLoadingFields = _b.isLoading, fieldsFailed = _b.isError;
    var _d = (0, react_3.useState)([]), groups = _d[0], setGroups = _d[1];
    var _e = (0, react_3.useState)({}), errors = _e[0], setErrors = _e[1];
    var _f = (0, react_3.useState)(false), isEdited = _f[0], setIsEdited = _f[1];
    // seeds only while nothing has been edited, so a background refetch cannot overwrite what is being built
    (0, react_3.useEffect)(function () {
        if (!isLoadingFields && !isEdited)
            setGroups((0, rules_1.toGroupDrafts)(segment.rules, fields));
    }, [segment.rules, fields, isLoadingFields, isEdited]);
    var handleChange = function (next) {
        setGroups(next);
        setErrors({});
        setIsEdited(true);
    };
    var handleSave = function () {
        var nextErrors = (0, rules_1.validateGroupDrafts)(groups, fields);
        setErrors(nextErrors);
        if (Object.keys(nextErrors).length > 0)
            return;
        dispatch((0, main_1.setContentModal)({
            title: "Save rule changes",
            content: (0, jsx_runtime_1.jsx)(SegmentRulesSaveForm, { segment: segment, rules: (0, rules_1.toSegmentRules)(groups, fields), on_saved: function () { return setIsEdited(false); } }),
        }));
    };
    var handleDiscard = function () {
        setErrors({});
        setIsEdited(false);
    };
    if (isLoadingFields)
        return (0, jsx_runtime_1.jsx)(react_1.Spinner, { size: "lg" });
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4 pt-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center justify-between gap-3", children: [fieldsFailed && (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-danger", children: "The available fields could not be loaded." }), canUpdate ? ((0, jsx_runtime_1.jsxs)("div", { className: "ml-auto flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "tertiary", isDisabled: !isEdited, onPress: handleDiscard, children: "Discard" }), (0, jsx_runtime_1.jsxs)(react_1.Button, { size: "md", variant: "primary", isDisabled: !isEdited, onPress: handleSave, children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "mdi:content-save", width: 24 }), "Save"] })] })) : ((0, jsx_runtime_1.jsx)(read_only_banner_1.ReadOnlyBanner, { feature: "segments" }))] }), (0, jsx_runtime_1.jsx)(segment_rules_builder_1.SegmentRulesBuilder, { groups: groups, fields: fields, errors: errors, on_change: handleChange, is_read_only: !canUpdate })] }));
}
